import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyD46d9C6ToqjIIj33DPJUEqga4pftax6mE',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'aftercredits-a9a33.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'aftercredits-a9a33',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'aftercredits-a9a33.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '207602883319',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:207602883319:web:b1b425c735736a4116d1f2',
  measurementId: 'G-4QBEM28GGX',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
